import React from "react";
import { Spinner } from "components/v2/spinner/spinner";
import "./shellSpinner.scss";

export interface ShellSpinnerProps {
  readonly isLoading: boolean;
}

const ShellSpinner: React.FC<ShellSpinnerProps> = ({ isLoading }) => {
  if (!isLoading) {
    return null;
  }

  return (
    <div className="shell-spinner" data-testid="shell-spinner">
      <Spinner isApi />
    </div>
  );
};

export default ShellSpinner;
